<template>
  <div>

    <div class="out-of-stock-btn" @click="open">
      <img class="icon"
      style="opacity: 0.6;"
        src="https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/zhongyaotishi.png"
        alt="">
      已售罄
    </div>

    <model-of-sell :visible.sync="bookingShow" :shorex="true" :outOfStock="true" />
  </div>

</template>

<script>
import ModelOfSell from './ModelOfLine.vue';

export default {
  components: {
    ModelOfSell
  },
  data() {
    return {
      img: 'https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/',
      bookingShow: false,
    }
  },
  methods: {
    open() {
      console.log('open')
      this.bookingShow = true;
    }
  }

}
</script>

<style lang="less" scoped>
.out-of-stock-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  font-size: 30px;
  color: #999;
  border-radius: 6px;
  width: 160px;
  height: 50px;
  font-size: 20px;
  background-color: #f0f0f0;
  line-height: 50px;

  & .icon {
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}
</style>